export default {
    main_menu: {
        home: 'Početna',
        company: 'Kompanija',
        my_companies: 'Moje kompanije',
        reservations: 'Moje rezervacije',
        timeline: 'Vremenska linija',
        made: 'Kreirane',
        received: 'Primljene',
        locations: 'Lokacija',
        locations_add: ' + Dodaj lokaciju',
        my_calendar: 'Moj kalendar',
        favorites: 'Omiljeni',
        offers: 'Usluge',
        contact: 'Kontakt',
        admin_reservations: 'Rezervacije',
        activate_member: 'Aktiviraj korisnika',
    },
    user_menu: {
        profile: 'Moj profil',
        go_to_admin_profile: 'Vrati se na admin profil',
        logout: 'Odjava',
    },
    top_menu: {
        create_company: 'Kreiraj kompaniju',
        create_service: 'Kreiraj uslugu',
        find_service: 'Pronađi uslugu',
        login: 'Prijava',
        find_offers: 'Pretraži usluge...',
        create_user_offer: 'Fizičko lice',
        create_company_offer: 'Pravno lice',
    },
}
